const [majorVersion] = window.OC?.config?.version?.split(".") ?? [];
const major = Number.parseInt(majorVersion ?? "34");
const isLegacy = major < 32;
const isLegacy34 = major < 34;
export {
  isLegacy as a,
  isLegacy34 as i
};
//# sourceMappingURL=legacy-BoqDmOCa.mjs.map
